import { render, staticRenderFns } from "./Bucket.vue?vue&type=template&id=128ad5d4&"
import script from "./Bucket.vue?vue&type=script&lang=js&"
export * from "./Bucket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports